import { MedisanteDevice } from '../../pages/Device/types';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';

export async function withOrganisationValidation<T>(
  orgIDs: string[],
  devices: MedisanteDevice[],
  validHandler: (orgId: string) => Promise<T | FetchBaseQueryError>
) {
  if (orgIDs.length > 1 && devices.length > 1) {
    return {
      error: {
        status: 400,
        data: 'There must be only one organisation selected!',
      },
    };
  } else if (orgIDs.length === 1) {
    return await validHandler(orgIDs[0]);
  }
  return await validHandler(devices[0].owner);
}

export const orgValidate = (orgIDs: string[], devices: MedisanteDevice[]) => {
  if (orgIDs.length > 1 && devices.length > 1) {
    return 'There must be only one organisation selected!';
  } else if (orgIDs.length === 1) {
    return null;
  }

  return null;
};
